<div class="create">
  <div class="header">
    <div class="title">Create a new report</div>
    <button mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="input_container">
        <label class="input_label">Name</label>
        <mat-form-field>
          <input placeholder="New report" matInput formControlName="name" />
        </mat-form-field>
      </div>
      <div class="input_container_object">
        <label class="input_label">Object</label>
        <mat-form-field>
          <mat-select formControlName="relatedToType" (selectionChange)="relatedToTypeChanged($event)">
            <mat-option *ngFor="let relatedToType of relatedToTypes" [value]="relatedToType.type">
              {{ relatedToType.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="create__time-series-flag" *ngIf="showTimeSeriesOption">
        <mat-label>Is Time Series?</mat-label><br />
        <mat-radio-group formControlName="report_type">
          <mat-radio-button value="time_series" class="yes">Yes</mat-radio-button>
          <mat-radio-button value="single_object">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="create()">Create</button>
  </mat-dialog-actions>
</div>
